<template>
    <div :style="style" class="background-area">
        <div :class="blurClass">
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useBackground } from '~/composables/useBackgroundArea';

const { style, blurClass } = useBackground();
</script>

<style scoped lang="scss">
.background-area {
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    height: 100%;
}
._blur-area {
    height: 100%;
    &::before {
        content: '';
        backdrop-filter: brightness(1.2) contrast(0.8) blur(4px);
        height: 100%;
        width: 100%;
        position: fixed;
    }
}
</style>
